import { useCallback, useEffect } from "react";

export const useKeyDownListener = (
    callback: (e: KeyboardEvent) => void,
    listenToKeys: string[],
) => {
    const onKeyDownHandler = useCallback(
        (e: KeyboardEvent) => {
            const keyMatch = listenToKeys.some((x) => e.key === x);

            if (keyMatch) {
                e.preventDefault();
                callback(e);
            }
        },
        [callback, listenToKeys],
    );

    useEffect(() => {
        document.addEventListener("keydown", onKeyDownHandler);

        return () => {
            document.removeEventListener("keydown", onKeyDownHandler);
        };
    }, [onKeyDownHandler]);
};
